let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dOb3j")).then(() => parcelRequire('1Jhrl'));